import {TransactionOptions, useContractFunction} from '@usedapp/core';
import {TransactionReceipt} from '@ethersproject/abstract-provider';
import {
    ContractFunctionNames,
    TypedContract,
} from '@usedapp/core/dist/esm/src/model/types';

import useShowStatus, {MessagesType} from '~hooks/useShowStatus';
import useTransactionLoading from '~hooks/useTransactionLoading';

export default function useContractWrite<
    T extends TypedContract,
    FN extends ContractFunctionNames<T>,
>(
    contract: T,
    functionName: FN,
    options?: TransactionOptions,
    messages?: MessagesType,
): [
    (
        ...args: Parameters<T['functions'][ContractFunctionNames<T>]>
    ) => Promise<TransactionReceipt | undefined>,
    boolean,
] {
    const {state, send} = useContractFunction(contract, functionName, options);

    useShowStatus(state, messages);

    const loading = useTransactionLoading(state);

    return [send, loading];
}
